import {Color, ThemeGetter} from '@styles/types';

/**
 * Use `quoteFg` from the theme.
 * If `quoteFg` is not provided by the theme,
 * will fall back to using the theme's `fg` color.
 */
export const quoteFg: ThemeGetter<Color> = ({theme}): Color =>
  theme.quoteFg || theme.fg;
